const pieces = [
  { icon: "ri-flashlight-line", name: "Moteur" },
  { icon: "ri-scissors-cut-line", name: "Sangle" },
  { icon: "ri-git-commit-line", name: "Cordon" },
  { icon: "ri-layout-masonry-line", name: "Tablier et lames" },
  { icon: "ri-equalizer-line", name: "Axe" },
  { icon: "ri-repeat-line", name: "Enrouleur" },
  { icon: "ri-link", name: "Attaches" },
  { icon: "ri-arrow-left-right-line", name: "Glissières" },
  { icon: "ri-remote-control-line", name: "Télécommande" },
];

export default function Pieces() {
  return (
    <section className="bg-brand-light py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <h2 className="text-brand-blue text-2xl md:text-3xl font-extrabold text-center mb-4">
          Toutes les pièces que nous remplaçons
        </h2>
        <p className="text-brand-text text-base leading-relaxed text-center max-w-2xl mx-auto mb-10 md:mb-14">
          Un volet roulant est composé de nombreuses pièces qui peuvent s'user ou se casser au fil du temps. Nous remplaçons chaque élément individuellement, ce qui vous permet de conserver votre volet existant sans investir dans une installation complète.
        </p>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-6">
          {pieces.map((p) => (
            <div key={p.name} className="bg-white rounded-xl p-5 md:p-6 text-center border border-brand-border hover:border-brand-cyan/40 transition-colors">
              <div className="w-10 h-10 flex items-center justify-center mx-auto mb-3">
                <i className={`${p.icon} text-brand-blue text-2xl`}></i>
              </div>
              <p className="text-brand-blue text-sm font-semibold">{p.name}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}